
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import MANAGEMENT_VISITS from "@/apollo/projectActivities/GetVisitsCounts.gql";
import MANAGER_VISITS from "@/apollo/projectActivities/GetVisitsCountsManager.gql";
import ProjectModal from "@/components/companyProjects/ProjectModalNew.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesV2.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubbleV2.vue";
import { Company, User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RouteTabs from "@/entities/RouteTabs";
import RouteNames from "@/entities/RouteNames";

interface VisitsData {
  draftedCount: {
    aggregate: {
      count: number;
    };
  };
  declinedCount: {
    aggregate: {
      count: number;
    };
  };
  assignedCount: {
    aggregate: {
      count: number;
    };
  };
  offeredCount: {
    aggregate: {
      count: number;
    };
  };
  emptyCount:{
    aggregate: {
      count: number;
    };
  };
  activeCount: {
    aggregate: {
      count: number;
    };
  };
  completedCount: {
    aggregate: {
      count: number;
    };
  };
}

@Component({
  components: {
    TabsWithRoutes,
    TabNotificationBubble,
    ProjectModal,
  },
  apollo: {
    visits: {
      query() {
        return this.isManager ? MANAGER_VISITS : MANAGEMENT_VISITS;
      },
      variables() {
        return this.visitsFilter;
      },
      update(data) {
        this.visits = data;
        return data;
      },
    },
  },
})
export default class AllVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  routes = RouteNames;
  containerClasses: string = "h-full";
  visits: VisitsData | null = null;

  dialog: boolean = false;

  @Watch("$route.fullPath")
  update() {
    this.$apollo.queries.visits.refetch();
  }

  get isManager(): boolean {
    return this.currentUser.role === "MANAGER";
  }
  get currentUserManagerId(): string {
    return this.currentUser.manager!.id;
  }

  get visitsFilter() {
    if (this.isManager) {
      return {
        managerId: this.currentUserManagerId,
      };
    }
    return {companyId: this.company.id};
  }

  get isResourcesPage(): boolean {
    return this.$route.path.includes("/company_database/");
  }
  get isTalentMapping(): boolean {
    return this.$route.path.includes("/talent-mapping");
  }
  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }
  get emptyTotal(): number {
    if (!this.visits || !this.visits.draftedCount) return 0;
    return (
      this.visits.draftedCount.aggregate.count +
      this.visits.declinedCount.aggregate.count +
      this.visits.offeredCount.aggregate.count +
      this.visits.emptyCount.aggregate.count
    );
  }

  get assignedTotal(): number {
    if (!this.visits || !this.visits.assignedCount) return 0;
    return this.visits.assignedCount.aggregate.count;
  }

  get completedTotal(): number {
    if (!this.visits || !this.visits.completedCount) return 0;
    return this.visits.completedCount.aggregate.count;
  }

  get routeTabs(): RouteTabs {
    return {
      [RouteNames.ALL_EMPTY_VISITS]: `Open visits`,
      [RouteNames.ACCEPTED_VISITS]: `Assigned`,
      [RouteNames.COMPLETED_VISITS]: `Completed`,
    };
  }

  toggle(): void {
    this.dialog = true;
  }
}
